import { Col, Row } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";

const SinglePromo = ({ promoId }, props): ReactElement => {
  const [promoData, setPromoData] = useState({
    loading: false,
    data: null,
  });

  const getSinglePromo = useCallback(() => {
    if (promoId) {
      try {
        setPromoData({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_ORDER_API}/admin/promo/details/${promoId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setPromoData({
                loading: false,
                data: data?.data?.promoCode,
              });
            } else {
              setPromoData({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setPromoData({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setPromoData({ loading: false, data: null });
        console.log(error, "error");
      }
    }
  }, [promoId]);

  useEffect(() => {
    getSinglePromo();
  }, [getSinglePromo]);

  console.log("Data :", promoId);

  return (
    <React.Fragment>
      <Row gutter={20}>
        <Col span={24}>
          <div className="inner-body-wrapper">
            <div className="inner-body">
              <div className="single">
                <div className="info-name">
                  <span>Promo Code</span>
                </div>
                <div className="info-desc">
                  <span>{promoData?.data?.promoCode}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Starting Time</span>
                </div>
                <div className="info-desc">
                  <span>
                    {moment(promoData?.data?.startFrom).format("lll")}
                  </span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Ending Time</span>
                </div>
                <div className="info-desc">
                  <span>{moment(promoData?.data?.endAt).format("lll")}</span>
                </div>
              </div>

              {promoData?.data?.joiningDateOfUser && (
                <div className="single">
                  <div className="info-name">
                    <span>Joining Date Of User</span>
                  </div>
                  <div className="info-desc">
                    <span>
                      {moment(promoData?.data?.joiningDateOfUser).format("lll")}
                    </span>
                  </div>
                </div>
              )}

              <div className="single">
                <div className="info-name">
                  <span>Maximum Allowed Usage</span>
                </div>
                <div className="info-desc">
                  <span>{promoData?.data?.maximumAllowedUsage}</span>
                </div>
              </div>

              {promoData?.data?.value?.flat && (
                <div className="single">
                  <div className="info-name">
                    <span>Amount </span>
                  </div>
                  <div className="info-desc">
                    <span>{promoData?.data?.value?.flat}</span>
                  </div>
                </div>
              )}

              {promoData?.data?.value?.percentage && (
                <div className="single">
                  <div className="info-name">
                    <span>Percentage </span>
                  </div>
                  <div className="info-desc">
                    <span>
                      {promoData?.data?.value?.percentage} {"%"}
                    </span>
                  </div>
                </div>
              )}

              {promoData?.data?.value?.maxLimit && (
                <div className="single">
                  <div className="info-name">
                    <span>Maximum Limit </span>
                  </div>
                  <div className="info-desc">
                    <span>{promoData?.data?.value?.maxLimit}</span>
                  </div>
                </div>
              )}

              {promoData?.data?.usedFor && (
                <div className="single">
                  <div className="info-name">
                    <span>Used For</span>
                  </div>
                  <div className="info-desc">
                    <span>{promoData?.data?.usedFor}</span>
                  </div>
                </div>
              )}

              {promoData?.data?.paymentMethod && (
                <div className="single">
                  <div className="info-name">
                    <span>Payment Method</span>
                  </div>
                  <div className="info-desc">
                    <span>{promoData?.data?.paymentMethod}</span>
                  </div>
                </div>
              )}

              {promoData?.data?.howManyInitialOrders ? (
                <div className="single">
                  <div className="info-name">
                    <span>How Many Initial Orders</span>
                  </div>
                  <div className="info-desc">
                    <span>{promoData?.data?.howManyInitialOrders}</span>
                  </div>
                </div>
              ) : undefined}

              {promoData?.data?.joiningDateOfUser && (
                <div className="single">
                  <div className="info-name">
                    <span>Joining Date Of User</span>
                  </div>
                  <div className="info-desc">
                    <span>
                      {moment(promoData?.data?.joiningDateOfUser).format("lll")}
                    </span>
                  </div>
                </div>
              )}

              {promoData?.data?.shopId && (
                <div className="single">
                  <div className="info-name">
                    <span>Shop ID</span>
                  </div>
                  <div className="info-desc">
                    <span>{promoData?.data?.shopId}</span>
                  </div>
                </div>
              )}

              {promoData?.data?.customerId && (
                <div className="single">
                  <div className="info-name">
                    <span>Customer ID</span>
                  </div>
                  <div className="info-desc">
                    <span>{promoData?.data?.customerId}</span>
                  </div>
                </div>
              )}

              <div className="single">
                <div className="info-name">
                  <span>Status</span>
                </div>
                <div className="info-desc">
                  <span
                    className={`radius-btn ${
                      promoData?.data?.isActive ? `active` : `inactive`
                    }-btn`}
                  >
                    {promoData?.data?.isActive ? `Active` : `Inactive`}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SinglePromo.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SinglePromo;
